const About = () =>{
    return(
        <div className="w-full min-h-96 flex justify-center items-center">
            <div className="w-11/12 bg-[#022B3A] text-[#E1E5F2] p-6 md:p-10">
                <p className="text-base md:text-lg mb-3">OnePercent is a website that could help you to be the best version of yourself by maintain all over the progress of work that you’re doing.  Because we know, Consistency is the Key. 
                </p>
                <p className="text-base md:text-lg">This website made by Ferry Febrian Lim ( Zenith Corp ) from 2024.</p>
            </div>
        </div>
    )
}

export default About